/**
 * Mapping mínimo de fieldId → display label para chips de métricas/dimensiones
 * en `ClientPortalReportsSection`. Los IDs vienen del snapshot `view.config` y
 * en Dashbo son mayormente legibles (Cost, Conversions, Campaign, etc.). Solo
 * mapeamos los que tienen un sufijo técnico (_ID) o un alias mejor.
 *
 * Si en el futuro el equipo de producto pide display names exactos del catálogo,
 * cambiar a un hook `useFieldLabels()` que fetch `node-to-gsheet/sync-configuration/form-data`
 * con cache en sessionStorage.
 */

// Los IDs canónicos vienen del backend en `looker_cc/fields_data.py` (snake_case en
// español, sin tildes — ej. `Campana`, `Grupo_de_Anuncios`). Diferenciamos los
// pares `*_ID` vs nombre porque son dimensiones distintas en el Data Explorer y
// pueden coexistir en `view.config.dimensions`: sin diferenciar, los chips
// colapsan visualmente al mismo label y aparece duplicado.
const FIELD_LABEL_OVERRIDES = {
    Canal: 'Canal',
    Cuenta: 'Cuenta',
    Cuenta_ID: 'Cuenta ID',
    Campana: 'Campaña',
    Campana_ID: 'Campaña ID',
    Grupo_de_Anuncios: 'Grupo de Anuncios',
    Grupo_de_Anuncios_ID: 'Grupo de Anuncios ID',
    Presupuesto: 'Línea de seguimiento',
    Presupuesto_ID: 'Línea de seguimiento ID',
    Cliente: 'Cliente',
    Cliente_ID: 'Cliente ID',
};

export function formatFieldId(fieldId) {
    if (!fieldId) return '';
    if (typeof fieldId !== 'string') return String(fieldId);
    if (FIELD_LABEL_OVERRIDES[fieldId]) return FIELD_LABEL_OVERRIDES[fieldId];
    // Fallback: limpiar sufijo "_ID" y subrayados → espacios.
    return fieldId.replace(/_ID$/, '').replace(/_/g, ' ');
}

/**
 * Extrae el ID de un item de `view.config.metrics` (puede ser string o `{name: ...}`).
 */
export function metricItemToFieldId(item) {
    if (!item) return '';
    if (typeof item === 'string') return item;
    return item.name || item.id || '';
}
